import { render } from "./CustomerDueReceive.vue?vue&type=template&id=a2e52d2e&scoped=true"
import script from "./CustomerDueReceive.vue?vue&type=script&lang=js"
export * from "./CustomerDueReceive.vue?vue&type=script&lang=js"

import "./CustomerDueReceive.vue?vue&type=style&index=0&id=a2e52d2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2e52d2e"]])

export default __exports__